import { render } from "./OrgTree.vue?vue&type=template&id=799ff377"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"

import "./OrgTree.vue?vue&type=style&index=0&id=799ff377&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__